import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './DataCard.scss';
import { AAMBeaconButton } from 'components/shared/Beacon';
const DataCard = ({
  className = '',
  cardTitle,
  cardHeaderTitle,
  cardMismatchBanner,
  cardHeaderCTAText = '',
  cardHeaderCTAVariant,
  cardHeaderCTAHandler,
  cardBody,
  cardFooterPrimaryCTAText,
  cardFooterPrimaryCTAHandler,
  cardFooterPrimaryCTAVariant,
  cardFooterPrimaryIconComponent,
  cardFooterSecondaryCTAText = '',
  cardFooterSecondaryCTAHandler,
  cardFooterSecondaryCTAVariant,
  cardFooterSecondaryIconComponent,
  isEditable
}) => {
  return (
    <Fragment>
      <div className={className}>
        <div className="b-typography-sans-serif--headline--100 b-font-weight-bold">
          {cardTitle}
        </div>
        <div className="data-card">
          <div className="card-Header">
            <div className="card-top">
              <h3 className="card-owner b-typography-sans-serif--headline--100 b-font-weight-bold blocked_data">
                {cardHeaderTitle}
              </h3>
              {cardHeaderCTAText && (
                <AAMBeaconButton
                  variant={cardHeaderCTAVariant}
                  scale="normal"
                  onBeaconEventClick={() => cardHeaderCTAHandler()}
                >
                  {cardHeaderCTAText}
                </AAMBeaconButton>
              )}
            </div>
            {cardMismatchBanner && (
              <div className="b-padding-block-end--micro--jumbo">
                {cardMismatchBanner}
              </div>
            )}
            <div className="section-border"></div>
          </div>
          <div className="b-grid">
            <div className="b-grid-item--12-col card-Content">{cardBody}</div>
          </div>
          <div className="card-Footer">
            {cardFooterPrimaryCTAText && isEditable && (
              <AAMBeaconButton
                className="card-Footer-PrimaryCTA"
                variant={cardFooterPrimaryCTAVariant}
                onBeaconEventClick={() => cardFooterPrimaryCTAHandler()}
                scale="normal"
              >
                {cardFooterPrimaryCTAText}
                {cardFooterPrimaryIconComponent &&
                  cardFooterPrimaryIconComponent}
              </AAMBeaconButton>
            )}
            {cardFooterSecondaryCTAText && isEditable && (
              <AAMBeaconButton
                className="card-Footer-Primary-CTAHandler"
                variant={cardFooterSecondaryCTAVariant}
                onBeaconEventClick={() => cardFooterSecondaryCTAHandler()}
                scale="normal">
                {cardFooterSecondaryCTAText}
                {cardFooterSecondaryIconComponent &&
                  cardFooterSecondaryIconComponent}
              </AAMBeaconButton>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

DataCard.propTypes = {
  className: PropTypes.string,
  cardHeaderTitle: PropTypes.node,
  cardHeaderCTAText: PropTypes.string,
  cardHeaderCTAVariant: PropTypes.string,
  cardHeaderCTAHandler: PropTypes.func,
  cardBody: PropTypes.node,
  cardFooterPrimaryCTAText: PropTypes.string,
  cardFooterPrimaryCTAHandler: PropTypes.func,
  cardFooterPrimaryCTAVariant: PropTypes.string,
  cardFooterPrimaryIconComponent: PropTypes.element,
  cardFooterSecondaryCTAText: PropTypes.string,
  cardFooterSecondaryCTAHandler: PropTypes.func,
  cardFooterSecondaryCTAVariant: PropTypes.string,
  cardFooterSecondaryIconComponent: PropTypes.element,
  cardMismatchBanner: PropTypes.node
};
export default DataCard;
